export const GET_MOVIES = 'GET_MOVIES';
export const SELECT_MOVIE = 'SELECT_MOVIE';
export const GET_SUGGESTIONS = 'GET_SUGGESTIONS';
export const UPDATE_MOVIE_SUCCESS = 'UPDATE_MOVIE_SUCCESS';
export const UPDATE_MOVIE_FAIL = 'UPDATE_MOVIE_FAIL';
export const REMOVE_MOVIE_SUCCESS = 'REMOVE_MOVIE_SUCCESS';
export const REMOVE_MOVIE_FAIL = 'REMOVE_MOVIE_FAIL';
export const TOGGLE_MOVIE_INTEREST = 'TOGGLE_MOVIE_INTEREST';
